export default "__VITE_ASSET__T9pAe5Cq__"